(function() {
  const el = document.querySelector(".header-wrapper .announcement");

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { height } = entry.contentRect;
      if (height > 0) {
        const siteHeader = document.querySelector("#SiteHeader");
        const searchNavigation = document.querySelector(".search-page__navigation-wrapper--mobile");
        const config = {
          stickyClass: 'site-header--stuck',
          openTransitionClass: 'site-header--opening',
        };

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        searchNavigation?.classList.remove(config.stickyClass);

        resizeObserver.unobserve(el);
      }
    }
  });

  resizeObserver.observe(el);
})();